// extracted by mini-css-extract-plugin
module.exports = {"filter":"filter__3xOxg","icon":"icon__1jE-V"};